module.exports = __webpack_public_path__ + "static/media/infoJumbo2.4adfb69c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/carif/images/infoJumbo2.jpg
// module id = 555
// module chunks = 0